import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export function AppProvider({ children }) {
  const [isAIPanelOpen, setIsAIPanelOpen] = useState(false);
  const [currentWorkspace, setCurrentWorkspace] = useState('Rank and Beyond');
  const [currentMission, setCurrentMission] = useState('Increase Q3 Qualified Pipeline by 20%');
  const [userRole, setUserRole] = useState('Contributor');

  const toggleAIPanel = () => setIsAIPanelOpen(!isAIPanelOpen);

  return (
    <AppContext.Provider value={{
      isAIPanelOpen, toggleAIPanel, setIsAIPanelOpen,
      currentWorkspace, setCurrentWorkspace,
      currentMission, setCurrentMission,
      userRole, setUserRole
    }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  return useContext(AppContext);
}